module.exports = __webpack_public_path__ + "img/3.b54f92c0.png";